import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorHeader: {
		id: 'navigation.preview-panel-global-objects.panels.error-header',
		defaultMessage: 'Can’t load details',
		description: 'Header for the preview panel error state',
	},
	errorDescription: {
		id: 'navigation.preview-panel-global-objects.panels.error-description',
		defaultMessage:
			'We’ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>.',
		description: 'Description for the preview panel error state',
	},
});
